import { render, staticRenderFns } from "./FighterIndex.vue?vue&type=template&id=4362c48b&lang=pug"
import script from "./FighterIndex.vue?vue&type=script&lang=js"
export * from "./FighterIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports